<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> AUDITORIA DE PEDIDOS </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-alert type="success" v-if="successSave">
        <template v-slot:close>
          <v-icon @click="() => (successSave = false)"> mdi-close </v-icon>
        </template>
        Evento salvo com sucesso
      </v-alert>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="months"
                v-model="month"
                label="Mês"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="years"
                v-model="year"
                label="Ano"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" md="4">
              <v-select
                :items="companies_providers"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                v-model="provider"
                label="Fornecedor"
                hide-details
                clearable
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" md="4" lg="4">
              <v-select
                :items="companies"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                v-model="company"
                label="Franqueado"
                hide-details
                clearable
                dense
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="6" md="3">
              <v-btn dark color="blue darken-3" small class="mt-1">
                <v-icon left> mdi-book-search-outline </v-icon>
                Executar Consulta
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-1">
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-btn small color="blue white--text">
                        <v-icon left> mdi-printer </v-icon>
                        Imprimir
                      </v-btn>
                      <v-btn
                        class="ml-4"
                        small
                        color="green darken-2 white--text"
                      >
                        <v-icon left> mdi-book-open-outline </v-icon>
                        Auditar
                      </v-btn>
                    </v-col>
                    <v-col xs="4" cols="2">
                      <v-spacer></v-spacer>
                      <v-text-field
                        label="Pesquisar"
                        dense
                        outlined
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-simple-table dense fixed-header height="200">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left text-no-wrap fs-12"></th>
                              <th class="text-left text-no-wrap fs-12">
                                Pedido
                              </th>
                              <th class="text-left text-no-wrap fs-12">
                                Estado
                              </th>
                              <th
                                class="text-left text-no-wrap fs-12"
                                width="180px"
                              >
                                Franqueado
                              </th>
                              <th
                                class="text-left text-no-wrap fs-12"
                                width="180px"
                              >
                                Fornecedor
                              </th>
                              <th class="text-left text-no-wrap fs-12">
                                Emissão
                              </th>
                              <th class="text-left text-no-wrap fs-12">
                                Estimativa
                              </th>
                              <th class="text-left text-no-wrap fs-12">
                                Valor
                              </th>
                              <th class="text-left text-no-wrap fs-12">
                                Qt. Itens
                              </th>
                              <th class="text-left text-no-wrap fs-12">
                                Qt. Atendida
                              </th>
                              <th class="text-left text-no-wrap fs-12">
                                Qt. Pendente
                              </th>
                            </tr>
                          </thead>
                          <tbody></tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>
<script>
// import { URL } from "@/api/config";

import * as CompanyAPI from "@/api/requests/CompanyRequest";

export default {
  components: {},
  data: () => ({
    months: [
      { value: 1, text: "Janeiro" },
      { value: 2, text: "Fevereiro" },
      { value: 3, text: "Março" },
      { value: 4, text: "Abril" },
      { value: 5, text: "Maio" },
      { value: 6, text: "Junho" },
      { value: 7, text: "Julho" },
      { value: 8, text: "Agosto" },
      { value: 9, text: "Setembro" },
      { value: 10, text: "Outubro" },
      { value: 11, text: "Novembro" },
      { value: 12, text: "Dezembro" },
    ],
    month: "",
    years: [],
    year: "",
    companies: [],
    companies_providers: [],
    company: "",
    provider: "",
    loading: false,
    successSave: false,
    lazy: false,
    valid: true,
  }),
  computed: {},
  created() {
    let dateNow = new Date();
    this.month = dateNow.getMonth() + 1;
    this.year = dateNow.getFullYear();

    let yearNow = dateNow.getFullYear();

    // COLOCA 10 ANOS PARA TRAS
    for (let i = 10; i >= 0; i--) {
      this.years.push(yearNow - i);
    }

    // MONTA O ARRAY INVERTIDO PARA MOSTRAR OS ANOS DESC
    this.years = this.years.reverse();

    this.initialize();
  },
  methods: {
    async initialize() {
      this.getCompanies();
      this.getProviders();
    },
    validate() {},
    async getCompanies() {
      // this.loading = true;
      try {
        let data = await CompanyAPI.getAll("?type=fra,mul");
        this.companies = data.sort((a, b) => (a.code > b.code ? 1 : -1));
      } catch (error) {
        this.companies = [];
        console.log(error);
      } finally {
        // this.loading = false;
      }
    },
    async getProviders() {
      // this.loading = true;
      try {
        let data = await CompanyAPI.getAll("?type=for");
        this.companies_providers = data.sort((a, b) =>
          a.code > b.code ? 1 : -1
        );
      } catch (error) {
        this.companies_providers = [];
        console.log(error);
      } finally {
        // this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11.5px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}
</style>
